import React, { useState, ChangeEvent } from "react"
import { useTranslation } from "react-i18next"
import "./Worksets.css"

interface WorksetNamePickerProps {
  onSearchEnter: (event: ChangeEvent<HTMLInputElement>) => void
  selection: string
  screen?: string
}

const WorksetNamePicker = ({ onSearchEnter, selection, screen }: WorksetNamePickerProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const { t } = useTranslation("worksets")

  return (
    <div>
      <div
        className="select-menu dropdown-pane-container"
        onBlur={(e) => {
          if (e.relatedTarget === null) setIsOpen(false)
        }}
      >
        <button
          data-testid="workset-name-picker-dropdown-button"
          className={`workset-name-picker ${screen === "small" ? "line-small-screen" : ""}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          {t("main.worksetNameFilterHeading")}
          {selection !== "" && <span className="badge pill primary workset-name-filter-badge">1</span>}
          <i className="icon-font tc-icon-arrow-drop-down"></i>
        </button>
        {isOpen && (
          <div
            data-testid="workset-name-picker-dropdown"
            className="dropdown-pane is-open dropdown workset-name-dropdown"
          >
            <div className="input-button-group search">
              <button className="button default hollow icon-medium icon-circle">
                <i className="icon-font tc-icon-search"></i>
              </button>
              <input
                type="text"
                placeholder={t("main.searchPlaceholder")}
                onChange={onSearchEnter}
                value={selection}
                data-testid="workset-name-picker-textbox"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default WorksetNamePicker
